var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isSelected && !_vm.isDescending
    ? _c("i", {
        staticClass: "fas fa-sort-down table-browser-clickable-icon",
        attrs: { id: "asc-sort", title: "Sort in descending order" },
        on: {
          click: function ($event) {
            return _vm.updateSort($event.target.id)
          },
        },
      })
    : _vm.isSelected && _vm.isDescending
    ? _c("i", {
        staticClass: "fas fa-sort-up table-browser-clickable-icon",
        attrs: { id: "desc-sort", title: "Sort in ascending order" },
        on: {
          click: function ($event) {
            return _vm.updateSort($event.target.id)
          },
        },
      })
    : _c("i", {
        staticClass: "fas fa-sort table-browser-clickable-icon",
        attrs: { id: "not-sort", title: "Sort in ascending order" },
        on: {
          click: function ($event) {
            return _vm.updateSort($event.target.id)
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }